export default __webpack_public_path__ + "static/media/policyadvisor.5dce79db.svg";